import * as investmentHoldingsV2Actions from './investmentHoldingsV2Actions';
import investmentHoldingsV2Reducer, { INVESTMENT_HOLDINGS_V2_REDUCER_KEY } from './investmentHoldingsV2Reducer';
import investmentHoldingsV2Sagas from './investmentHoldingsV2Sagas';
import * as investmentHoldingsV2Selectors from './investmentHoldingsV2Selectors';
import * as investmentHoldingsV2Types from './investmentHoldingsV2Types';

const INVESTMENT_HOLDINGS_V2_VERSION_NUMBER = 3;

export {
  INVESTMENT_HOLDINGS_V2_REDUCER_KEY,
  INVESTMENT_HOLDINGS_V2_VERSION_NUMBER,
  investmentHoldingsV2Types,
  investmentHoldingsV2Selectors,
  investmentHoldingsV2Actions,
  investmentHoldingsV2Reducer,
  investmentHoldingsV2Sagas,
};
